import { QuestionCreatedMessage } from '@/queries/community-feed/types';
import { trackMP } from '@/shared/mp';

import Card, { CardProps } from './Card';
import { CardHabitatLink } from './CardLink';
import { getQuestionQueryParams } from './utils';

const QuestionCreatedCard = ({ messageWithMeta }: CardProps<QuestionCreatedMessage>) => {
  return (
    <Card messageWithMeta={messageWithMeta}>
      <p className="preflight preflight-p line-clamp-3">
        left a question for{' '}
        <CardHabitatLink
          message={messageWithMeta.message}
          onClick={() => {
            trackMP('community-feed-clicked', {
              content: 'habitat',
            });
          }}
        >
          {messageWithMeta.message.habitat.title} keepers at {messageWithMeta.message.zoo.name}
        </CardHabitatLink>
        :{' '}
        <CardHabitatLink
          message={messageWithMeta.message}
          query={getQuestionQueryParams(messageWithMeta.message)}
          onClick={() => {
            trackMP('community-feed-clicked', {
              content: 'question',
            });
          }}
        >
          {messageWithMeta.message.question.text}
        </CardHabitatLink>
      </p>
    </Card>
  );
};

export default QuestionCreatedCard;
